import { call, fork, put, takeEvery } from 'redux-saga/effects';

import {
  CREATE_CASE_FROM_ALERT,
  createCaseFromAlertSuccess,
  createCaseFromAlertFail
} from '../../redux/actions/cm/convertAlertsToCase';

import { createCaseFromAlerts } from '../../services/cm/alerts';

function* createCaseFromAlert({ alertIds, departmentId }) {
  try {
    // FIN-12949/FIN-13021 — carry the BE's partial-outcome lists through to the page so the
    // analyst is told what was skipped instead of seeing a blanket success.
    const { caseId, skippedAlreadyCased, skippedUnknown } = yield call(
      createCaseFromAlerts,
      { alertIds, departmentId }
    );
    yield put(
      createCaseFromAlertSuccess({
        caseId,
        skippedAlreadyCased,
        skippedUnknown
      })
    );
  } catch (error) {
    yield put(createCaseFromAlertFail(error));
  }
}

export function* watchCreateCaseFromAlert() {
  yield takeEvery(
    CREATE_CASE_FROM_ALERT,
    function* ({ payload: { alertIds, departmentId } }) {
      yield fork(createCaseFromAlert, { alertIds, departmentId });
    }
  );
}
